<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            消费流水
        </div>
        <div style="padding: 22px;">
            <div>
                <el-row>
                    <div style="float:right">
                        <el-form :inline="true" class="demo-form-inline">
                            <el-form-item>
                                <el-input placeholder="请输入姓名" v-model="name" clearable style="width:200px;"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input placeholder="请输入手机号" v-model="phone" clearable style="width:200px;"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <Daterange :startTime="startTime" :endTime="endTime" @dataChange='dataChange'></Daterange>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="success" icon="el-icon-download" @click="download">导出</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" @click="searchGetList()">搜索</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div>
                <template>

                    <el-table
                        :data="tableData"
                        :height="th"
                        border
                        v-loading="loading"
                        style="width: 100%;">
                        <el-table-column prop="businessName" label="商家名称"></el-table-column>
                        <el-table-column prop="user.name" label="姓名" width="120"></el-table-column>
                        <el-table-column prop="user.phone" label="联系电话" width="120"></el-table-column>
                        <el-table-column prop="price" label="消费金额" width="105"></el-table-column>
                        <el-table-column prop="currentBalance"  label="余额" width="80"></el-table-column>
                        <el-table-column
                                prop="orderType"
                                :formatter="statusTitle"
                                label="订单类型" width="150">
                        </el-table-column>
                        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>
                    </el-table>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条  <span>每页显示条数</span>
                        </div>
                      <div style="float: left;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-sizes="[20, 50, 100, 200]"
                            :page-size="20"
                            layout="sizes, prev, pager, next"
                            :total="totalItems"
                        >
                        </el-pagination>
                      </div>
                        <div style="clear: both;"></div>
                    </div>
                    

                </template>
            </div>

        </div>


    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import Daterange from "@/components/Daterange";
    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                startTime:'',
                endTime:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
            }
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight-15;
        },
        components:{Daterange
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val-15;
            },
        },
        methods:{
            init(){
                this.endTime =timefilters(new Date()).slice(0,10);
                this.startTime=timefilters(new Date(new Date() - 1000 * 60 * 60 * 24 * 365)).slice(0,10);
            },
          handleSizeChange(val){
            this.pageSize=val;
            this.getList();
          },
          handleCurrentChange(val){
            this.currentPage=val;
            this.getList();
          },
          dataChange(val){
                this.startTime=val[0]
                this.endTime=val[1]
            },
            getZoneValue(val){
                this.zoneCode=val
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            searchGetList(){
                this.getList();
            },
            download(){
            this.$confirm('是否导出当前列表?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.showModal=true
              var that=this

              this.$axios.get(this.$shopUrl+'ExportOldest/GetBusinessWater',{
                responseType: 'blob',
                params:{
                  timeStr: timeStr,
                  sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  staffCode: getStaffCode(),
                  startTime:timefilters(this.datetimerangeValue[0]),
                  endTime:timefilters(this.datetimerangeValue[1]),

                }
              }).then(
                  (response) => {
                    if(response.data.type=='application/json'){
                      this.$message({type: 'info', message: '暂无数据'});
                      that.showModal=false;
                    }else{
                      let fileName = '商家消费流水统计.xlsx';
                      that.file(response,fileName);
                      that.showModal=false;
                    }

                  }
              )
              this.dialogFormVisible=false
            }).catch(e=>e)
          },
          file(response,fileName){
            let blob = new Blob([response.data]);
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob,fileName);
            } else {
              let elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href);
              document.body.removeChild(elink);
            }
          },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"OrderBusiness/PageForWater",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        name:this.name,
                        phone:this.phone,
                    }
                }).then( (response)=> {
                  this.loading=false;
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            applyTypeTitle(row){
                if(row.applyType == 0){
                    return "80-99周岁";
                }
                if(row.applyType == 1){
                    return "100周岁及以上";
                }
            },
            genderTitle(row, column, cellValue){
                if(cellValue == 0){
                    return "女";
                }
                if(cellValue == 1){
                    return "男";
                }
            },
             statusTitle(row, column, cellValue){
                 return this.allStatus(cellValue,["",'普通商品订单','社会化服务订单','政府购买服务订单']);
            },
            isSchedules(row, column, cellValue){
                 return this.allStatus(cellValue,['否','是']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            }


        }
    }
</script>

<style scoped>

</style>
